import React, { createRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Slider from 'react-slick/lib/slider';
import useIsMobile from './Hooks/useIsMobile'
import { CaretLeft, CaretRight } from 'phosphor-react';
import QuantityPurchaseContainer from '../Containers/QuantityPurchase.Container';
import FavouriteButtonContainer from '../Containers/FavouriteButton.container';

const store = window.__litium.store = window.__litium.store || (window.parent.__litium && window.parent.__litium.store)
  || createStore(app, preloadState, composeWithDevTools(applyMiddleware(thunk, historyMiddleware)));

const arrowSize = 50;

const NextArrow = ({ onClick }) => {
  return (
    <div className="slick-arrow slick-arrow__right" onClick={onClick}>
      <CaretRight size={arrowSize} />
    </div>
  );
};
const PrevArrow = ({ onClick }) => {
  return (
    <div className="slick-arrow slick-arrow__left" onClick={onClick}>
      <CaretLeft size={arrowSize} />
    </div>
  );
};

const ProductSliderBlock = ({ productCardElements }) => {
  const isMobile = useIsMobile();
  const thisContainer = createRef();
  const settings = {
    slidesToShow: isMobile ? 2 : 6,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    initialSlide: 0,
    centerMode: false,
    infinite: false,
  };
  useEffect(() => {
    Array.from(thisContainer.current.getElementsByClassName('quantity-purchase')).forEach((elem) => {
      const { quantityfieldid, packagesize, allowsingleitem, articlenumber, productname, price, variant, brand, category, isKeg, isCategoryPage } = elem.dataset;
      ReactDOM.render(
        <Provider store={store}>
          <QuantityPurchaseContainer
            {...{
              packageSize: packagesize,
              allowSingleItem: allowsingleitem,
              articleNumber: articlenumber,
              productName: productname,
              price: price,
              variant: variant,
              brand: brand,
              category: category,
              isKeg: isKeg,
              isCategoryPage: isCategoryPage === "True",
            }}
          />
        </Provider>,
        elem
      );
    });

    Array.from(thisContainer.current.getElementsByClassName('favourite-button')).forEach((favouriteButton) => {
      const { articlenumber } = favouriteButton.dataset;
      ReactDOM.render(
        <Provider store={store}>
          <FavouriteButtonContainer {...{ articleNumber: articlenumber }} />
        </Provider>,
        favouriteButton
      );
    });
  });
  return (
    <ul className="product-producer" ref={thisContainer}>
      <Slider {...settings}>
        {productCardElements.map((cardElem, index) => (
          <li className='productsinslider'
            key={index}
            dangerouslySetInnerHTML={{ __html: cardElem.innerHTML }}
          ></li>
        ))}
      </Slider>
    </ul>
  );
};

export default ProductSliderBlock;
